import { Converter } from '../types/converter';

export const illuminationConverter: Converter = {
  id: 'illumination',
  name: 'Illumination Converter',
  icon: 'Sun',
  categories: ['light'],
  units: [
    { name: 'Lux', symbol: 'lx', factor: 1 },
    { name: 'Meter-candle', symbol: 'm*c', factor: 1 },
    { name: 'Centimeter-candle', symbol: 'cm*c', factor: 10000 },
    { name: 'Foot-candle', symbol: 'ft*c', factor: 10.7639 },
    { name: 'Flame', symbol: 'flame', factor: 0.0929 },
    { name: 'Phot', symbol: 'ph', factor: 10000 },
    { name: 'Nox', symbol: 'nox', factor: 0.001 },
    { name: 'Candela steradian/square meter', symbol: 'cd·sr/m²', factor: 1 },
    { name: 'Lumen/square meter', symbol: 'lm/m²', factor: 1 },
    { name: 'Lumen/square centimeter', symbol: 'lm/cm²', factor: 10000 },
    { name: 'Lumen/square foot', symbol: 'lm/ft²', factor: 10.7639 },
    { name: 'Watt/square centimeter (at 555 nm)', symbol: 'W/cm² (at 555 nm)', factor: 6830000 }
  ]
};
